/* eslint-disable react-hooks/exhaustive-deps */

import { TextAlignment } from "@blueprintjs/core"
import { createElement, useEffect, useRef } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { WriterContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useInViewport } from "src/modules/pe-landing-module/hooks/useInViewport"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { IPrimitiveProps } from "../../section/Primitive"
import "./jumper.scss"

/* Protopia Ecosystem component */ 
const Jumper = (props: IPrimitiveProps): JSX.Element => {
    const ref = useRef(null)
    const primitive: WriterContent = (props.primitive || {}) as WriterContent 
    const { style, className, variant, } = primitive 
    const text = primitive.text  
    const children = useSyncState<any[]>([])
    const position = usePosition( primitive ).position  
    const isEdit = useLandingStore((state: ILandingStore) => state.isEdit)
    const inViewport = useInViewport(ref, 300)
    
    const getText = () => {
        return text
        .replaceAll("</p><p>", "\n")
        .replaceAll("<br>", "\n")
        .split("\n")
    }
    const onStart = () => {
        children.set([])
        let n = 0
        const variantClassName = [
            "jump-letter-up", 
            "jump-letter-left"
        ]
        const chld: any[] = getText()
        .map((line, i) => {
            return createElement(
                'div', 
                { className: `jumper-line-${i} d-flex justify-content-${ primitive.text_align || TextAlignment.CENTER }`, key: i }, 
                ...[ 
                    ...line.split("").map(
                        (letter, ii) => {
                            /*
                            return createElement(
                                'span', 
                                { className: `jump-letter-cont`, key: ii },
                                [
                                    <span className="not-jump-letter" key={1}>{letter}</span>,
                                    <span className={ variantClassName[ variant || 0 ] } style={{ animationDelay: `${ 50 * ++n - i * 200 }ms` }} key={2}>{letter}</span>
                                ]
                            )
                            */
                            return createElement(
                                'span', 
                                { 
                                    className: `jump-letter-cont`, 
                                    style: { 
                                        animationDelay: `${ 50 * ++n - i * 100 }ms`,
                                        animationName: variant,
                                        minWidth: 10
                                    }, 
                                    key: ii 
                                }, 
                                letter
                            )
                        } 
                    )
                ]
            )
        }) 
        setTimeout(() => children.set( chld ), 50)
    }
    
    useEffect(() => {
        addCSSClass(
            `primitive-writer-${ primitive.id }`,
            ` .primitive-writer-${ primitive.id } { 
                width:${ getCssDemention(position.width, "300px") };
                height:${ getCssDemention( getText().length * ( (primitive.text_size || 35)*1.4 ), "300px") };
                ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg);` }
                text-align:${primitive.text_align || TextAlignment.START};
                ${ primitive.text_size   ? `font-size: ${ primitive.text_size }px!important;` : "" }
                ${ primitive.font_weight   ? `font-weight: ${ primitive.font_weight }!important;` : "" }
                ${ primitive.text_color  ? `color: ${primitive.text_color}!important;` : "" };
                ${ primitive.font ? `font-family: ${primitive.font }!important;` : ""}
            }`
        ) 
        return () => removeCSSClass(`primitive-writer-${ primitive.id }`)
    },[ position, primitive ])
    
    useEffect(() => {
        if(inViewport) {
            onStart()
        }
    }, [ inViewport, primitive ])

    return <div 
       style={ style }
        className={`landing-jumper-container ${isEdit ? "" : " " }  primitive-writer-${ primitive.id } ${ className }` }  
        ref={ref} 
        onClick={onStart} 
    >
        { children.get() }
    </div>
}
export default Jumper